import { render, staticRenderFns } from "./InvoicesActions.vue?vue&type=template&id=482c16f0&scoped=true"
import script from "./InvoicesActions.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicesActions.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicesActions.vue?vue&type=style&index=0&id=482c16f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c16f0",
  null
  
)

export default component.exports